export const NO_SERVICE = { id: 'no_service', label: 'Nessun servizio' };
export const PUBLIC_FAMILY_COUNSELING = {
  id: 'public_family_counseling',
  label: 'Consultorio familiare pubblico',
};
export const PUBLIC_HOSPITAL_CLINIC = {
  id: 'public_hospital_clinic',
  label: 'Ambulatorio ospedaliero pubblico',
};
export const PRIVATE_GYNECOLOGIST_OR_MIDWIFE = {
  id: 'private_gynecologist_or_midwife',
  label: 'Ginecologo o ostetrica privato (compreso intramoenia)',
};
export const PRIVATE_FAMILY_COUNSELING = {
  id: 'private_family_counseling',
  label: 'Consultorio familiare privato',
};
export const PSYCHOLOGIST_ADVICE = { id: 'psychologist_advice', label: 'Consulenza psicologo' };
